
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-alert v-if="error" type="error">{{error}}</v-alert>
            <v-container>
              <v-card-title>
                Benutzer von {{ app.name }}
                <div class="flex-grow-1"></div>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Suche" single-line></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="headers"
                        :items="list"
                        :search="search"
                        :items-per-page="50"
                        class="elevation-1"
                      >
                        <template
                          v-slot:item.customerId="{ item }"
                        >{{ customer.filter(x => x.id == item.customerId).length > 0 ? customer.filter(x => x.id == item.customerId)[0].name : "-" }}</template>
                        <template
                          v-slot:item.created="{ item }"
                        >{{ item.created | moment("DD.MM.YYYY HH:mm") }}</template>
                        <template
                          v-slot:item.lastLogin="{ item }"
                        >{{ item.lastLogin | moment("DD.MM.YYYY HH:mm") }}</template>
                        <template v-slot:item.edit="{item}">
                          <v-btn small @click="editUser(item.id)">Bearbeiten</v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn color="primary" @click="addUser">Benutzer hinzufügen</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppService from "@/services/AppService";
import CustomerService from "@/services/CustomerService";
import UserService from "@/services/UserService";
import Header from "@/views/general/header";
import router from "@/plugins/router";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    app: {},
    list: [],
    customer: null,
    search: null,
    headers: [
      { text: "#", value: "id", sotable: true, align: "left" },
      { text: "Kunde", value: "customerId", sotable: true, align: "left" },
      { text: "Benutzername", value: "name", sotable: true, align: "left" },
      { text: "E-Mail", value: "email", sotable: true, align: "left" },
      { text: "Erstellt am", value: "created", sotable: true, align: "left" },
      {
        text: "Letzer Login",
        value: "lastLogin",
        sotable: true,
        align: "left"
      },
      { text: "Bearbeiten", value: "edit", sotable: false, align: "left" }
    ]
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    addUser() {
      router.push({ name: "AddUser", params: { id: this.$route.params.id } });
    },
    editUser(id) {
      router.push({
        name: "EditUser",
        params: { id: this.$route.params.id, userId: id }
      });
    },
    async refresh() {
      this.loading = true;
      try {
        let data = (await AppService.getApp(this.$route.params.id)).data;
        if (data) {
          this.app = data;
        } else {
          this.app = { name: "APP NICHT GEFUNDEN" };
          router.replace("/apps");
        }

        data = (await UserService.get(this.app.id)).data;
        this.customer = (await CustomerService.get(this.app.id)).data;
        if (data) {
          this.list = data;
        } else {
          this.list = [];
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.error = err.message;
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

